export default "__VITE_ASSET__BevUVQ$M__"